
  <div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>Fitkidz (Sports) Program Details</h2>
        <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
        <p>
          The Fitkidz program is Innovative Vision's foundational sports initiative for pre-primary
           children. It is designed to introduce young children to the joys of physical 
           activity in a structured, safe, and engaging environment.  
           The program's core philosophy aligns with our holistic approach, developing not 
           just the body but also the mind and character.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/ourProgramDH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>
<div class="key-focus-section m-3">
  <div class="image-container">
    <img src="assets/ivimg/PD-1.svg" alt="Key Focus Areas"/>
  </div>
  <div class="content">
    <h2 class="section-title">Key Focus Areas</h2>
    <div class="points">
      <p>
        <strong>1. Physical Development:</strong> The curriculum is centered on enhancing
        fundamental physical attributes crucial for a child's growth. This includes
        improving gross motor skills, which are essential for activities like running,
        jumping & throwing. We also focus on developing coordination, balance,
        agility & endurance.
      </p>
      <p>
        <strong>2. Character Building:</strong> Beyond physical skills, Fitkidz emphasizes
        core life values. The program is designed to foster discipline by teaching
        children to follow instructions and respect rules. It also builds confidence
        and promotes a sense of teamwork and healthy competition.
      </p>
    </div>
  </div>
</div>


<div class="program-highlights">
  <div class="highlight-container">
    <!-- Image from assets -->
    <div class="image-container">
      <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
    </div>

    <!-- Text Content -->
    <div class="text-container">
      <h2 class="title">Program Highlights</h2>
      <p>
        <strong>Structured Curriculum:</strong> Our program is not just free play. It is based on
        an outcome-based curriculum with a clear progression of skills.
      </p>
      <p>
        <strong>Age-Appropriate Activities:</strong> The sessions are tailored for specific age
        groups (e.g., 2–3 years, 3–4 years, 4–6 years) to ensure activities are both
        challenging and fun.
      </p>
      <p>
        <strong>Play-Based Learning:</strong> We use games, fun drills, and imaginative scenarios
        to make learning physical skills an exciting experience. This ensures children stay
        engaged and develop a lifelong positive association with physical activity.
      </p>
    </div>
  </div>
</div> 


<div class="benefits-section">
  <h2 class="benefits-title">Benefits for Your Child</h2>
  <p class="benefits-text">
    Our Fitkidz program is a holistic investment in your child's complete
    well-being. It is designed to deliver comprehensive benefits that extend far
    beyond physical fitness. By engaging in our play-based learning activities,
    your child will experience improved physical health, enhanced mental focus &
    better social skills. Our curriculum is tailored to improve endurance,
    strength, flexibility & gross motor skills, while simultaneously boosting
    their concentration, problem-solving skills & cognitive function. This is
    all done in a team-oriented environment that fosters communication,
    cooperation & increased self-esteem, building a strong foundation for their
    physical, mental & social growth.
  </p>
</div>
